import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sliderList: null,
    displaySliderItem: null
};

export const sliderSlice = createSlice({
    name: "slider",
    initialState,
    reducers: {
        updateSlider: (state, action) => {
            state.sliderList = action.payload;
        },
        clearSlider: (state) => {
            state.sliderList = null;
        },
        updateDisplaySliderItem: (state, action) => {
            state.displaySliderItem = action.payload;
        }   
    },
});

export const { updateSlider, clearSlider, updateDisplaySliderItem } = sliderSlice.actions;

export default sliderSlice.reducer;